import React from 'react';
import './PrivacyPolicy.css';

interface PrivacyPolicyProps {
  onClose: () => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onClose }) => {
  return (
    <div className="privacy-overlay" onClick={onClose}>
      <div className="privacy-modal" onClick={(e) => e.stopPropagation()}>
        <button className="privacy-close" onClick={onClose} aria-label="Chiudi">
          ×
        </button>
        <div className="privacy-content">
          <h1>Privacy Policy</h1>
          <p className="privacy-intro">
            <strong>Gioco per Tutti - GPT</strong><br />
            Associazione culturale senza scopo di lucro<br />
            C.F./P.IVA: 90290520734<br />
            Via Per Mare, 80 - 74020 Maruggio (TA)
          </p>

          <section>
            <h2>1. Titolare del Trattamento</h2>
            <p>
              Il Titolare del trattamento dei dati personali è l'Associazione culturale "Gioco per Tutti - GPT",
              con sede in Via Per Mare, 80 - 74020 Maruggio (TA), C.F./P.IVA: 90290520734.
            </p>
          </section>

          <section>
            <h2>2. Tipologia di dati trattati</h2>
            <p>Il presente sito web è una landing page informativa.

              Attualmente non vengono raccolti né trattati dati personali degli utenti tramite il sito.
              Non sono presenti moduli di contatto, sistemi di registrazione, newsletter o strumenti di profilazione.</p>
          </section>

          <section>
            <h2>3. Dati di navigazione</h2>
            <p>
              Il sito non utilizza strumenti di tracciamento, né sistemi di analisi delle visite.

              Eventuali dati tecnici generati dalla navigazione (es. richieste HTTP) non vengono utilizzati dal Titolare per identificare gli utenti e non sono oggetto di analisi o profilazione.
            </p>
          </section>

          <section>
            <h2>4. Cookie</h2>
            <p>
            Questo sito non utilizza cookie di profilazione né cookie di terze parti.

Possono essere presenti esclusivamente <strong>cookie tecnici</strong>, necessari al corretto funzionamento del sito, che non richiedono il consenso dell’utente ai sensi della normativa vigente.
            </p>
          </section>

          <section>
            <h2>5. Comunicazione e Diffusione</h2>
            <p>
            Non essendo effettuata alcuna raccolta di dati personali tramite il sito, nessun dato viene comunicato o diffuso a terzi.
            </p>

          </section>

          <section>
            <h2>6. Diritti dell'Interessato</h2>
            <p>
            Gli utenti possono esercitare in qualsiasi momento i diritti previsti dagli articoli 15 e seguenti del Regolamento UE 2016/679 (GDPR), contattando il Titolare all’indirizzo email indicato.
            </p>
            <p>
              Per esercitare i propri diritti, l'interessato può rivolgersi al Titolare all'indirizzo email:
              <a href="mailto:info@giocopertutti.it">info@giocopertutti.it</a>
            </p>
          </section>

          <section>
            <h2>7. Modifiche alla presente Privacy Policy</h2>
            <p>
            La presente Privacy Policy potrà essere aggiornata qualora il sito venga ampliato con nuovi servizi o funzionalità che comportino il trattamento di dati personali.
            Le modifiche saranno pubblicate su questa pagina.
            </p>
          </section>

          <section>
            <h2>8. Contatti</h2>
            <p>
              Per qualsiasi richiesta relativa al trattamento dei dati personali o per esercitare i propri diritti,
              è possibile contattare il Titolare:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:info@giocopertutti.it">info@giocopertutti.it</a><br />
              <strong>Indirizzo:</strong> Via Per Mare, 80 - 74020 Maruggio (TA)
            </p>
          </section>

          <p className="privacy-date">
            <em>Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

